export default __webpack_public_path__ + "static/plant on circle-dca72fdfe3c2f7c12a2d4c7db3cf04c2.svg";